import React from "react";
import { Input, Card, Form } from "antd";
import Button from "react-bootstrap/Button";
import { APP_NAME, APP_DOMAIN } from '../../../../data/appData';
import AuthLayout from "../../../layouts/AuthLayout"
import { toAbsoluteUrl } from "../../../../_metronic/_helpers"
import styled from 'styled-components'

const WrapCard = styled(Card)(() => `
	background-color: transparent;
	border: none;
	color: #fff;
	text-align: center;
	.ant-input-group-addon {
		background-color: transparent;
		border: none;
		color: white;
	}
	#url {
		border-radius: 3px;
	}
`)

const onSubmit = (value) => {
	window.location.href = `https://${value?.url}${APP_DOMAIN}`
}

function LoginDomain() {
	return (
		<AuthLayout
			ktLoginStyle={{ backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-login.jpg")})` }}
			asideContent={
				<>
					<p className="font-weight-bold font-size-h3">
						One system, limitless use cases.
					</p>
					<p className="font-size-lg">
						For finance and beyond!
					</p>
				</>
			}
		>
			<div className="d-flex flex-column flex-root">
				<div
					className="login login-4 login-signin-on d-flex flex-row-fluid"
					id="kt_login"
				>
					<div className="d-flex flex-center flex-column flex-row-fluid bgi-size-cover bgi-position-top bgi-no-repeat">
						<WrapCard>
							<div className="login-form login-signin" id="kt_login_signin_form">
								<div className="mb-10">
									<h3>Welcome to {APP_NAME}</h3>
									<p>Please enter your {APP_NAME} login domain</p>
								</div>
								<Form onFinish={onSubmit}>
									<fieldset>
										<Form.Item
											rules={[{ required: true, message: 'Please input your domain' }]}
											name="url">
											<Input
												id="url"
												addonAfter={APP_DOMAIN}
												placeholder="yourdomain" />
										</Form.Item>
										<Form.Item>
											<Button
												id="kt_login_signin_submit"
												type="submit"
												className="btn btn-primary font-weight-bold px-9"
												block
											>
												<span>Continue</span>
											</Button>
										</Form.Item>
										<div className="d-flex justify-content-center">
											<a href="https://docs.unifiplatform.com/" className="tel text-white">Need help ?</a>
										</div>
									</fieldset>
								</Form>
							</div>
						</WrapCard>
					</div>
				</div>
			</div>
		</AuthLayout>
	);
}
export default LoginDomain
